module.exports = __webpack_public_path__ + "static/media/codup.9d46ce8f.jpg";